import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidSyllabicKeyboardFreeform } from '../../../../mechanics/rid-syllabic-keyboard-freeform/rid-syllabic-keyboard-freeform';

@Component({
  selector: 'app-monosyllabic-keyboard-freeform-page',
  imports: [RidSyllabicKeyboardFreeform],
  templateUrl: './monosyllabic-keyboard-freeform-page.html',
})
export class MonosyllabicKeyboardFreeformPage {
  protected readonly $activatedRoute = inject(ActivatedRoute);
  protected readonly $router = inject(Router);

  protected readonly mode = () => this.$activatedRoute.snapshot.queryParams['mode'] as 'GROUP' | 'KLANK' | 'BOTH';
}
